module.exports = __webpack_public_path__ + "static/media/TasklyDoubleDiamond.c4752001.png";